import styled from 'styled-components'
import { Button } from '@chegg-ui/button'
import { Special } from '@chegg-wt/core/theme/fanta/button'
import { Input } from '@chegg-ui/input'
import { spacing } from '@chegg-ui/theme'
import FantaTheme from '@chegg-wt/core/theme/fanta/theme'
import { values } from '@chegg-wt/core/theme/sunkist/spacing'
import { BodyLargeBold, BodyBold, Body } from '@chegg-wt/core/theme/sunkist/typography'

export const Container = styled.div`
  margin-top: 8px;
`

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const NoteInput = styled(Input)`
  margin: 0;
`

export const Header = styled.div`
  ${BodyLargeBold};
  ${({ theme }) => theme.Colors.textColorGray};
`

export const Hide = styled.div`
  ${BodyBold};
  color: ${FantaTheme.colors.link};
  cursor: pointer;
`

export const PostButton = styled(Button)`
  ${Special}
  margin: ${spacing.px12} 0;
`

export const Notenotenote = styled.div`
  display: flex;
`

export const NoteName = styled.p`
  ${BodyBold};
  margin-right: ${values.xxsmall};
`

export const NoteDate = styled.p`
  color: ${FantaTheme.colors.greyMedium};
  font-size: 14px;
`

export const NoteText = styled.p`
  ${Body};
`
